import React, { useContext } from "react";
import { HeaderBanner as HeaderBannerBase } from "@dscience/header-banner";
import { MyContext } from "../context/MyContext";
import headerBannerImage from "../assets/images/header_banner_air_quiz.png";

export default function HeaderBanner() {
  const { isAppMode } = useContext(MyContext);

  return (
    <HeaderBannerBase
      image={headerBannerImage}
      backgroundColor="#9362FF"
      link="https://smore.im/form/5dzNgB6J41"
      endDate="2026-05-27"
      hidden={isAppMode}
      className="ui-top-banner on"
    />
  );
}
